export function formatNumberWithCommas(number) {
  return new Intl.NumberFormat().format(number)
}
